// extracted by mini-css-extract-plugin
export default {"invalid":"Invalid_invalid__GUF3M"};